import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createClient } from "api/client.api";
import {
  invalidateClientSide,
  invalidateDashboardSources,
} from "lib/cacheInvalidation";

export const useCreateClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createClient,
    onSuccess: () => {
      invalidateClientSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
